import styled from 'styled-components';

export const CardData = styled.div.attrs({ className: 'CardData' })`
  padding: 8px 0 8px 14px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
`;
